import { render, staticRenderFns } from "./ChooseDoctor.vue?vue&type=template&id=b43cfa9e&scoped=true"
import script from "./ChooseDoctor.vue?vue&type=script&lang=js"
export * from "./ChooseDoctor.vue?vue&type=script&lang=js"
import style0 from "./ChooseDoctor.vue?vue&type=style&index=0&id=b43cfa9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43cfa9e",
  null
  
)

export default component.exports